<template>
  <div class="aging-table">
    <vue-good-table
        id="aging-table"
        ref="table"
        :columns="columns"
        :rows="orders"
        :search-options="{
          enabled: true,
          trigger: 'enter',
          skipDiacritics: true,
          placeholder: 'Search this table',
        }"
        :pagination-options="{
          enabled: true,
          mode: 'pages',
          perPage: 10,
        }"
        @on-row-click="onRowClick"
      >
        <div slot="table-actions">
          <button @click="exportXLSX()" class="export">
            <svg viewBox="0 0 384 512"><path d="M369.9 97.98L286.02 14.1c-9-9-21.2-14.1-33.89-14.1H47.99C21.5.1 0 21.6 0 48.09v415.92C0 490.5 21.5 512 47.99 512h288.02c26.49 0 47.99-21.5 47.99-47.99V131.97c0-12.69-5.1-24.99-14.1-33.99zM256.03 32.59c2.8.7 5.3 2.1 7.4 4.2l83.88 83.88c2.1 2.1 3.5 4.6 4.2 7.4h-95.48V32.59zm95.98 431.42c0 8.8-7.2 16-16 16H47.99c-8.8 0-16-7.2-16-16V48.09c0-8.8 7.2-16.09 16-16.09h176.04v104.07c0 13.3 10.7 23.93 24 23.93h103.98v304.01zM64 208v224c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16zm224 208h-80v-48h80v48zm0-80h-80v-48h80v48zM96 224h192v32H96v-32zm0 64h80v48H96v-48zm0 80h80v48H96v-48z"/></svg>
          </button>
        </div>
      </vue-good-table>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table';
import { jsonToExcel, formatAging } from '../jsonToExcel';

export default {
  name: 'Aging-Report',
  props: {
    orders: Array
  },
  components: {
    VueGoodTable
  },
  data() {
    return {
      columns: [
        {
          label: 'Order Date',
          field: 'orderDate',
          width: '150px',
        },
        {
          label: 'Order ID',
          field: 'orderReference',
          width: '100px',
          filterOptions: {
            enabled: true,
            placeholder: 'Filter',
          }
        },
        {
          label: 'Item ID',
          field: 'itemSKU',
        },
        {
          label: 'Item Name',
          field: 'itemName',
          width: '300px'
        },
        {
          label: 'Product Description',
          field: 'productDescription',
          width: '300px'
        },
        {
          label: 'Qty',
          field: 'qty',
        },
        {
          label: 'Campaign Item',
          field: 'campaignItem',
        },
        {
          label: 'Program Name',
          field: 'programName',
          width: '200px',
          filterOptions: {
            enabled: true,
            placeholder: 'Filter',
          }
        },
        {
          label: 'Account Name',
          field: 'accountName',
          width: '200px'
        },
        {
          label: 'Status',
          field: 'status',
          filterOptions: {
            enabled: true,
            placeholder: 'Filter',
          }
        },
        {
          label: 'Order Age',
          field: 'age',
          width: '100px',
          filterOptions: {
            enabled: true,
            placeholder: 'Filter',
          }
        },
        {
          label: 'RD Id',
          field: 'rdId'
        },
        {
          label: 'RD Name',
          field: 'rdName'
        },
        {
          label: 'RD Email',
          field: 'rdEmail'
        },
        {
          label: 'Instructions',
          field: 'instructions',
          width: '300px'
        },
        {
          label: 'Action',
          field: this.itemsBtn,
          html: true
        }
      ]
    }
  },
  methods: {
    onRowClick (params) {
      const order = params.row
      window.location.href = `/rd/order?id=${order.id}`;
    },
    itemsBtn () {
      return '<button class="rounded-full flex items-center text-base text-white shadow-solid bg-green py-2 px-4">Review</button>'
    },
    exportXLSX() {
      let results = this.$refs.table.filteredRows[0].children

      if (results.length === 0 ) {
        results = this.orders;
      }

      let rows = formatAging(results);

      jsonToExcel(rows, this.columns, "Aging Report", `aging-report-${new Date().toISOString()}.xlsx`);
    },
  }
}
</script>